import axios from 'axios';

// Create axios instance with default headers
const apiClient = axios.create({
  headers: {
    'X-Internal-Client': true
  }
});

// Base URL for your API
const baseUrl = process.env.REACT_APP_BASE_URL || 'http://localhost:8080/api'; // replace with your actual base URL

// API Service
const ApiService = {
  // Get Today's Result
  getTodayResult: async (siteId) => {
    return apiClient.get(`${baseUrl}/results/today/${siteId}`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching today\'s result:', error);
        throw error;
      });
  },


  // Get Previous Result for a specific site and number of days
  getPreviousResult: async (siteId, days) => {
    return apiClient.get(`${baseUrl}/results/previous-week/${siteId}`)
      .then(response => response.data)
      .catch(error => {
        console.error('Error fetching previous result:', error);
        throw error;
      });
  },

  getCurrentResult: async (siteId) => {
    return apiClient.get(`${baseUrl}/results/current/${siteId}`)
    .then(response => response.data)
    .catch(error => {
      console.error('Error fetching sites:', error);
      throw error;
    });
  }
};

export default ApiService;
